import React from "react";
import authStorage from "./authStorage";

const headerService = () => {
  const BEARER = authStorage();
  // headers
  const headersWithAuth = () => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: BEARER,
    };
  };
  return headersWithAuth();
};

export default headerService;
